import preact, { h, Component } from 'preact'
import Tabbar from './components/Tabbar'
import TransitionFade from './components/TransitionFade'
import ConfigProvider from './config/ConfigProvider'

import { IntlProvider } from 'preact-i18n'

export default class App extends Component {
    constructor(props, context) {
        super(props)
        this.setState = this.setState.bind(this)
        this.state = context.config.initialState

        this.goto = name => {
            let step = this.context.config.steps.find(({name: x}) => x == name)
            if (step) {
                this.setState({currentStep: step})
            }
        }

        this.setCurrentStep = currentStep => this.setState({currentStep})
    }

    render(props, { currentStep }, { config: {steps, translations} }) {
        let app = (
            <IntlProvider definition={translations}>
                <div class="limba">
                    <Tabbar items={steps} current={currentStep} onChange={this.setCurrentStep} />
                    <TransitionFade component={currentStep.view} componentName={currentStep.name} state={this.state} setState={this.setState} goto={this.goto} />
                </div>
            </IntlProvider>
        )
        return app
    }
}


// WEBPACK FOOTER //
// ./js/App.js